module.exports = __webpack_public_path__ + "static/grafika4-ea82684e482b7020f0e27c3123ac205a.png";